module.exports = __webpack_public_path__ + "media/images/placeholders/category@2x-9eaf1ef9011f706f64725722f06924df.png";